import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ProductLanguageService {
  public languages: string[] = ["en-US", "de-DE"];

  public init(languages: string[]) {
    this.languages = languages;
  }

  selectLanguage(language: string): string[] {
    if (!this.languages.includes(language)) {
      this.languages.push(language);
    }
    return this.languages;
  }
}
